import { render, staticRenderFns } from "./BannerDA.vue?vue&type=template&id=d192f7d8&scoped=true&"
import script from "./BannerDA.vue?vue&type=script&lang=js&"
export * from "./BannerDA.vue?vue&type=script&lang=js&"
import style0 from "./BannerDA.vue?vue&type=style&index=0&id=d192f7d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d192f7d8",
  null
  
)

export default component.exports